/**
 * Fair Home V2 — H11 scroll (YSL parity)
 * Ref audit: ysl.com = Swiper vertical + effect creative + mousewheel; ours draws the same
 * effect without Swiper (`useFairHomeV2OwnPager`).
 * Soft CSS snap was rejected — this is the real pager.
 */

/** Class on `document.documentElement` while Home v2 pager is mounted */
export const FAIR_HOME_V2_SCROLL_ROOT_CLASS = 'fair-home-v2-scroll'

/** YSL's timing. A swipe made during the transition re-aims the pager, so none is lost. */
export const FAIR_HOME_V2_PAGER_SPEED_MS = 500

export const FAIR_HOME_V2_SCROLL_SNAP_SECTION_IDS = [
  'hero',
  'capsules',
  'services',
  'selected',
  'ai',
  'popular',
  'footer',
] as const

export type FairHomeV2ScrollSnapSectionId =
  (typeof FAIR_HOME_V2_SCROLL_SNAP_SECTION_IDS)[number]

export function isFairHomeV2ScrollSnapSection(
  id: string,
): id is FairHomeV2ScrollSnapSectionId {
  return (FAIR_HOME_V2_SCROLL_SNAP_SECTION_IDS as readonly string[]).includes(id)
}

/** Sections that may overflow one viewport — clip to 100dvh (YSL has no inner page scroll). */
export const FAIR_HOME_V2_PAGER_SCROLLABLE_SECTION_IDS = [] as const

export function isFairHomeV2PagerScrollableSection(id: string): boolean {
  return (FAIR_HOME_V2_PAGER_SCROLLABLE_SECTION_IDS as readonly string[]).includes(
    id,
  )
}
